module.exports = __webpack_public_path__ + "img/desc7.eee09f37.png";